//export const BASE_URL = 'https://app-dev.partner-api.myeasytransfer.com/v1';
export const BASE_URL = 'https://www.partner-api.myeasytransfer.com/v1'
//export const BASE_URL = 'http://192.168.235.95:9090/v1';
//API End Points

export const LOGIN = '/auth/login'
export const LISTUSERS = '/users'
export const ADDTAUX = '/fxrates/fxrate'
export const GETFXRATES = '/fxrates'
export const GETTRANSFERS = '/transfers/listForAdmin'
export const VALIDTRANSFER = '/transfers/completeTransfer'
export const GETCOMMISSIONS = '/commissions'
export const ADDCOMMISSIONS = '/commissions/commission'
export const GETIMAGE = '/files/file'
export const CONFIRMEDCLIENT = '/users/confirm'
export const UPDATETRANSFER = '/files/file'
export const GETBALANCE = '/settings/getBalance'
export const UPDATEBALANCE = '/settings/updateBalance'
export const ADDAGENT = '/users/newAgent'
export const GETONETRANSFER = '/transfers/oneTransfer'
export const GETLISTBALANCE = '/balances/list'
export const GETBALANCETRANSFER = '/transfers/getBalanceTransfers'
export const SendSms = '/transfers/sendSmsFromAdmin'
export const CancelTranfer = '/transfers/cancelTransfer'

